import { Button } from "@/components/ui/button";
import { MapPin, X, Settings } from "lucide-react";
import { useState } from "react";

interface LocationConsentModalProps {
  open: boolean;
  onConsent: (granted: boolean, rememberChoice: boolean) => void;
}

export const LocationConsentModal = ({ open, onConsent }: LocationConsentModalProps) => {
  if (!open) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 animate-in slide-in-from-bottom duration-300">
      <div className="bg-card border-t border-border shadow-2xl">
        <div className="container mx-auto px-4 py-4">
          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 justify-between">
            {/* Icon and Message */}
            <div className="flex items-start gap-3 flex-1">
              <MapPin className="w-5 h-5 text-primary mt-0.5 flex-shrink-0" />
              <div className="flex-1">
                <p className="text-sm font-medium mb-1">
                  We use location data for analytics
                </p>
                <p className="text-xs text-muted-foreground">
                  We collect GPS coordinates, city, and region to provide localized experiences. 
                  Data is stored for 90 days and can be deleted anytime.{' '}
                  <a 
                    href="/privacy" 
                    target="_blank" 
                    className="text-primary hover:underline"
                  >
                    Privacy Policy
                  </a>
                  {' · '}
                  <a 
                    href="/privacy-settings" 
                    target="_blank" 
                    className="text-primary hover:underline inline-flex items-center gap-1"
                  >
                    <Settings className="w-3 h-3" />
                    Manage Preferences
                  </a>
                </p>
              </div>
            </div>

            {/* Action Buttons */}
            <div className="flex items-center gap-2 flex-shrink-0 w-full sm:w-auto">
              <Button
                variant="outline"
                size="sm"
                onClick={() => onConsent(false, true)}
                className="flex-1 sm:flex-initial"
              >
                Decline
              </Button>
              <Button
                size="sm"
                onClick={() => onConsent(true, true)}
                className="flex-1 sm:flex-initial"
              >
                Accept
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
